import React, { Component } from 'react'
import Header from './LoginHeader.jsx';

const AdminLoginLayout = () => {
    return (
        <Header/>
    )
}
export default AdminLoginLayout;